export const onwheelCustomersData = [
  {
    id: '1',
    title: 'Ngành hàng F&B',
    imgDesktop:
      '/static/images/service/industry-image/img-nganh-hang-f&b-desktop.webp',
    imgMobile:
      '/static/images/service/industry-image/img-nganh-hang-f&b-mobile.webp',
    services: [
      'Cơ chế điều phối đơn hàng đa tầng thông minh: Auto-Dispatch, Auto-Fallback',
      'Tính cơ động: Tối đa hóa tỉ lệ hoàn thành đơn - Giảm thiểu tương tác với thiết bị di động',
      'Hệ thống cảnh báo shipper đơn hàng trễ leadtime giao hàng, trễ leadtime lấy hàng',
    ],
    link: 'https://cafef.vn/mot-thap-ky-lo-nuong-chua-bao-gio-nguoi-lua-pizza-4ps-van-giu-nguyen-ven-trai-nghiem-thuc-khach-tu-nha-hang-toi-ban-bep-gia-dinh-20211206202849921.chn',
    customersLogo: [
      {
        src: '/static/images/service/customer-logo/img-the-coffee-house-logo.webp',
        alt: 'The coffee house',
        type: 'rectangle',
      },
      {
        src: '/static/images/service/customer-logo/img-pizza-4p-logo.webp',
        alt: 'Pizza 4Ps',
        type: 'other',
      },
    ],
  },
  {
    id: '2',
    title: 'Siêu thị, chuỗi bán lẻ',
    imgDesktop:
      '/static/images/service/industry-image/img-sieu-thi-chuoi-ban-le-desktop.webp',
    imgMobile:
      '/static/images/service/industry-image/img-sieu-thi-chuoi-ban-le-mobile.webp',
    services: [
      'Quản lý cụm cửa hàng riêng biệt',
      'Đối soát COD với tài xế ',
      'Cơ chế điều phối đơn hàng thông minh',
      'Báo cáo đầy đủ chỉ số vận hành',
    ],
    link: 'https://zingnews.vn/dai-dich-mo-duong-de-central-retail-giai-bai-toan-chuyen-doi-so-post1322543.html',
    customersLogo: [
      {
        src: '/static/images/service/customer-logo/img-f99-logo.webp',
        alt: 'F99',
        type: 'square',
      },
      {
        src: '/static/images/service/customer-logo/img-sai-gon-coop-logo.webp',
        alt: 'Saigon Coop',
        type: 'square',
      },
      {
        src: '/static/images/service/customer-logo/img-go-bigc-logo.webp',
        alt: 'Go!Big C',
        type: 'rectangle',
      },
    ],
  },
  {
    id: '3',
    title: 'Sản xuất, xây lắp',
    imgDesktop:
      '/static/images/service/industry-image/img-san-xuat-xay-lap-desktop.webp',
    imgMobile:
      '/static/images/service/industry-image/img-san-xuat-xay-lap-mobile.webp',
    services: [
      'Quản lý chi phí phát sinh của đơn hàng, phương tiện',
      'Biểu phí shipping',
      'Tối ưu dường đi với tính năng gợi ý loại xe phù hợp',
    ],
    link: 'https://cafebiz.vn/go-an-cuong-khoi-dau-tu-tam-nhin-va-vuon-toi-su-hoan-hao-trong-nganh-noi-that-go-176221224125528794.chn',
    customersLogo: [
      {
        src: '/static/images/service/customer-logo/img-an-cuong-logo.webp',
        alt: 'An Cuong Logo',
        type: 'square',
      },
    ],
  },
  {
    id: '4',
    title: 'Kho vận, phân phối',
    imgDesktop:
      '/static/images/service/industry-image/img-kho-van-phan-phoi-desktop.webp',
    imgMobile:
      '/static/images/service/industry-image/img-kho-van-phan-phoi-mobile.webp',
    services: [
      'Cập nhật thông tin kiện hàng real time (Location, E-POD, E-Signature)',
      'Cấu hình lưu trữ dữ liệu toàn trình và số Seal/Cont nhằm gia tăng mức độ bảo mật.',
      'Các báo cáo liên quan.',
    ],
    link: 'https://drive.google.com/file/d/1YNz1yAVqAyHi_sOlmqz8Nw1fiZy4Q-cm/view?usp=share_link',
    customersLogo: [
      {
        src: '/static/images/service/customer-logo/img-gear-vn-logo.webp',
        alt: 'GearVN',
        type: 'square',
      },
      {
        src: '/static/images/service/customer-logo/img-thuoc-si-logo.webp',
        alt: 'Thuoc si',
        type: 'rectangle',
      },
    ],
  },
];
